const OurFocusSection = () => {
  return (
    <section className="bg-white py-48">
      <div className="w-4/5 mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-24 h-px bg-[#2B2D33] mx-auto mb-8"></div>
          <h2
            className="text-5xl font-light text-[#2B2D33] leading-tight mb-10"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Built for Commercial Operators, Not General Consulting
          </h2>

          <p className="text-lg text-[#6B6D72] leading-relaxed max-w-3xl mx-auto">
            We work selectively with commercial mechanical, fire protection, and specialty trade contractors across the Southeast United States.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurFocusSection;
